import React from "react";
import { useSelector } from "react-redux";
// Scss
import "./TroubledProjectsDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import TPIcon from "assets/icons/tp-icon.svg";
import CostValueIcon from "assets/icons/cost-value.svg";
import PieSlicesIcon from "assets/icons/pie-slices.svg";
import WalletIcon from "assets/icons/wallet.svg";
import ConstructionProjectsIcon from "assets/icons/construction-new.svg";
import RenovationProjectsIcon from "assets/icons/renovation-new.svg";
import TransformationProjectsIcon from "assets/icons/transformation-new.svg";
import HeartIcon from "assets/icons/heart-new.svg";
import NoteWhiteIcon from "assets/icons/note-white.svg";
import NoteWhiteIconLight from "assets/icons/notesmall-white-light.svg";
import TTCIcon from "assets/icons/ttc.svg";
import TTCIconLight from "assets/icons/ttc-light.svg";

// Importing Components
import StackedChart from "components/charts/StackedCharts";
import SmallPie from "components/charts/SmallPie";

// Importing Packages
import "animate.css";

function TroubledProjectsDashboard() {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);
  return (
    <>
       {/* Dropdowns Wrapper */}
       <section className="dropdowns-wrapper">
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Central</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Eastern</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>North Western</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Northern</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>S. Project</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
            <div className="dropdown-container">
              {selectedTheme === "dark" ? (
                <img src={DropdownAngle} alt="#" />
              ) : (
                <img src={DropdownAngleLight} alt="#" />
              )}
              <select>
                <option>Southern</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
          </section>
      {/* Troubled Projects Pane */}
      <section className="troubled-projects-wrapper">
        <div className="troubled-projects-container">
          <div className="cp-title">
            <img src={TPIcon} alt="#" />
            <span>Troubled Projects</span>
          </div>
          <div className="cp-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice And Right Section Slice Info */}
      <section className="grid-wrapper-troubled">
        <div className="left-section-container">
          <div className="top">
            <div className="info">
              <div className="budget-revised">
                <div className="budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span className="budget-light">Budget</span>
                  </div>
                  <div className="information">
                    <span className="revised">33,597</span>
                    <span className="budget-sar">SAR</span>
                  </div>
                </div>
                <div className="revised-budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span className="budget-light">
                      Revised <br />
                      Budget
                    </span>
                  </div>
                  <div className="information">
                    <span className="revised">33,597</span>
                    <span className="budget-sar">SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="e-p-costvalue">
                <div className="p-cost-value blank">
                  <div className="icon-container">
                    <img src={CostValueIcon} alt="#" />
                    <span>
                      Planed Cost <br /> Value
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
                <div className="e-cost-value blank">
                  <div className="icon-container">
                    <img src={CostValueIcon} alt="#" />
                    <span>
                      Earned Cost <br /> Value
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="pie-info">
                <div className="icon-container">
                  <img src={PieSlicesIcon} alt="#" />
                </div>
                <span>SPI</span>
                <div className="chart">
                  <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                  <span>45%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="middle-section-container">
          <div className="head">
            <span>
            {
                  selectedTheme === 'dark'?<img src={NoteWhiteIcon} alt="#" />:<img src={NoteWhiteIconLight} alt="#" />
                }
              Planned Vs Actual Performance Over Years
            </span>
          </div>
          <div className="body">

            {
              selectedTheme === 'dark'?
              <StackedChart
              data={{
                categories: ["2016", "2018", "2020", "2022"],
                data: [
                  [37.8, 20.3, 40.8, 16.8],
                  [37.8, 20.3, 40.8, 56.8],
                ],
              }}
              colorset={{
                firstSet: ["rgba(36, 160, 217, 1)", "rgba(49, 56, 61, 1)"],
                secondSet: ["rgba(214, 0, 0, 0.5)", "rgba(49, 56, 61, 1)"],
              }}

              linecolor={"#272C2F"}
              label={"#f1f2f3"}
            />:
            <StackedChart
            data={{
              categories: ["2016", "2018", "2020", "2022"],
              data: [
                [37.8, 20.3, 40.8, 16.8],
                [37.8, 20.3, 40.8, 56.8],
              ],
            }}
            colorset={{
              firstSet: ["rgba(36, 160, 217, 1)", "rgba(49, 56, 61, 1)"],
              secondSet: ["rgba(214, 0, 0, 0.5)", "rgba(49, 56, 61, 1)"],
            }}

            linecolor={"#f1f2f3"}
            label={"#424B51"}
          />
            }
           
          </div>
        </div>
        <div className="right-section-container">
          <div className="head">
            <span>
            {
                  selectedTheme === 'dark'?<img src={NoteWhiteIcon} alt="#" />:<img src={NoteWhiteIconLight} alt="#" />
                }
              Troubled Projects / Region
            </span>
          </div>
          <div className="body">
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Region</th>
                    <th>Budgets</th>
                    <th># Of Projects</th>
                    <th>Budget (SAR)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Northern</td>
                    <td>124,324,214</td>
                    <td>3</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>124,324,214</td>
                    <td>3</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>124,324,214</td>
                    <td>3</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>124,324,214</td>
                    <td>3</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>124,324,214</td>
                    <td>3</td>
                    <td>123,342,344</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Progress Graph Section */}
      <section className="projects-progress-graph-wrapper">
        <div className="projects-progress-graph-container">
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info darkblue">
              <div className="head">
                <span>
                  <img src={ConstructionProjectsIcon} alt="#" />
                  Construction Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalgreen"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalgreen">
              <div className="head">
                <span>
                  <img src={RenovationProjectsIcon} alt="#" />
                  Renovation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white wastewater">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white wastewater">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalorange"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalorange">
              <div className="head">
                <span>
                  <img src={TransformationProjectsIcon} alt="#" />
                  Transformation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white tse">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white tse">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalblue">
              <div className="head">
                <span>
                  <img src={HeartIcon} alt="#" />
                  Supportive Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Troubled Contributers / Projects Section */}
      <section className="troubled-contributers-projects-wrapper">
        <div className="troubled-contributers-projects-container">
          <div className="left">
            <div className="head">
              <span>
              {selectedTheme === "dark" ? (
                      <img src={TTCIcon} alt="#" />
                    ) : (
                      <img src={TTCIconLight} alt="#" />
                    )}
                Top Troubled Contributers
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Contractors</th>
                      <th>Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ a نأ</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
              {selectedTheme === "dark" ? (
                      <img src={TTCIcon} alt="#" />
                    ) : (
                      <img src={TTCIconLight} alt="#" />
                    )}
                Top Troubled Projects (Budgets)
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Regions</th>
                      <th>Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>Northern</td>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TroubledProjectsDashboard;
